<div>
  <div #chatContainer [id]="containerId()" style="height: 900px">Loading chats...</div>
</div>
